import { tickerItems } from '@/mocks/home';

export default function TickerBar() {
  const looped = [...tickerItems, ...tickerItems];

  return (
    <section className="w-full bg-primary-950">
      <div className="flex h-12 items-center gap-4 px-4 md:px-8">
        <span className="flex shrink-0 items-center gap-2 border-r border-primary-50/20 pr-4 text-sm font-bold text-accent-400">
          <i className="ri-pulse-line flex h-4 w-4 items-center justify-center text-base" />
          实时热度
        </span>
        <div className="relative flex-1 overflow-hidden">
          <div className="animate-hl-marquee flex w-max items-center gap-10">
            {looped.map((item, index) => (
              <span
                key={`${item}-${index}`}
                className="flex items-center gap-2 whitespace-nowrap text-[13px] text-primary-50/80"
              >
                <span className="h-1.5 w-1.5 rounded-full bg-primary-400" />
                {item}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}